<template>
  <div v-if="data" class="articles single-article">
    <div class="container">
      <div class="container__liner">
        <div id="navigation">
          <div class="breadcrumbs">
            <a href="/" class="breadcrumbs-item">Главная</a>
            <a :href="href" class="breadcrumbs-item">{{ isAction ? 'Акции' : 'Новости и статьи' }}</a>
            <a v-if="typeName" :href="`/articles?type=${data.type}`" class="breadcrumbs-item"> {{ typeName }}</a>
            <span class="breadcrumbs-item">{{ data.title }}</span>
          </div>
        </div>
        <div class="title">
          <h1 id="pagetitle">
            <span>{{ pageH1 }}</span>
          </h1>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="container__liner">
        <div class="entry">
          <div class="entry__date">
            {{ dateArticle }}
          </div>
          <div v-html="data.content" class="entry__content">
            <!-- Article Content -->

          </div>
          <div class="entry__continue">
            <div v-if="data.tags.length" class="entry__tags">
              <div class="entry__label">
                Метки {{ relatedName() }}
              </div>
              <a
                  v-for="(tag, ind) in data.tags"
                  :key="ind"
                  :href="`${href}?tag=${tag.id}`"
                  class="entry__tag inviting">
                {{ tag.title }}
              </a>
            </div>

            <div v-if="showRelated" class="entry__items">
              <div class="knowledge">
                <div class="title knowledge__title">
                  <h2>{{ isAction ? 'Другие акции' : 'Читайте также' }}</h2>
                </div>

                <div class="knowledge__items" v-if="data.related.rand.length > 0">
                  <article-item
                      v-for="(event, index) in data.related.rand"
                      :key="index"
                      :init-data="event"
                  />
                </div>

                <div class="explore" v-if="data.related.prev !== data.id">
                  <div class="explore__navigation explore__steps">
                    <a :href="`${href}/${data.related.prev}`" class="explore__step">
                      <span class="explore__prev arrow-left">
                        <svg class="icon icon-left">
                          <use xlink:href="@/assets/img/elem//symbols.svg#icon-left"></use>
                        </svg>
                      </span>
                      Предыдущая {{ relatedName(true) }}
                    </a>
                    <a :href="`${href}/${data.related.next}`" class="explore__step">
                      Следующая {{ relatedName(true) }}
                      <span class="explore__next arrow-right">
                        <svg class="icon icon-left">
                          <use xlink:href="@/assets/img/elem/symbols.svg#icon-right"></use>
                        </svg>
                      </span>
                    </a>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
import ArticleItem from '../components/Article.vue'
import { fetchNewsDetail, fetchNewsList } from '../api/adminBrands'
import { metaFromSeoOrDefaults } from '../seo/metaFromStore'

export default {
  components: {
    ArticleItem
  },
  data() {
    return {
      data: null,
    }
  },
  computed: {
    isAction() {
      return /акци/i.test(String(this.data && this.data.type ? this.data.type : ''))
    },
    dateArticle() {
      const raw = this.data && this.data.date && this.data.date.date
        ? this.data.date.date
        : this.data.date
      if (!raw) return ''
      return this.$moment(raw).format('DD MMMM YYYY')
    },
    typeName() {
      return this.data && this.data.type ? this.data.type : false
    },
    href() {
      if(this.$route.path.includes('articles')) return '/articles'
      else if(this.$route.path.includes('actions')) return '/actions'
      return '/'
    },
    showRelated() {
      if (this.data.related) {
        if (this.data.related.rand.length > 0 || this.data.related.prev !== this.data.id) return true
      }
      return false
    },
    pageH1() {
      return this.data && this.data.title ? this.data.title : ''
    },
  },
  methods: {
    async getInitDataArticle() {
      let article
      try {
        article = await fetchNewsDetail(this.$route.params.id)
      } catch (e) {
        return
      }
      if (!article) return

      const relatedList = await fetchNewsList({
        type: article.type,
        page: 1,
        limit: 20,
        excludeBanner: true,
      }).catch(() => ({ data: [] }))

      const others = (relatedList.data || []).filter((item) => item.id !== article.id)
      const index = (relatedList.data || []).findIndex((item) => item.id === article.id)
      const prev = (relatedList.data || [])[index - 1] || others[others.length - 1]
      const next = (relatedList.data || [])[index + 1] || others[0]

      this.data = {
        ...article,
        related: {
          rand: others.slice(0, 3),
          prev: prev ? prev.id : article.id,
          next: next ? next.id : article.id,
        },
      }
    },
    relatedName(arrows = false) {
      const type = String(this.data && this.data.type ? this.data.type : '').toLowerCase()
      if (type.includes('акци')) return arrows ? 'акция' : 'акции:'
      if (type.includes('новост')) return arrows ? 'новость' : 'новости:'
      if (type.includes('стать')) return arrows ? 'статья' : 'статьи:'
      return arrows ? 'страница' : 'страницы:'
    },
  },
  beforeMount() {
    this.getInitDataArticle()
  },
  metaInfo() {
    const articleTitle = this.data && this.data.title ? this.data.title : 'Новости и статьи'
    return metaFromSeoOrDefaults(this.$store, {
      title: articleTitle,
      titleTemplate: `%s - ${process.env.VUE_APP_NAME}`,
    })
  },
}
</script>